import React from 'react'
import PropTypes from 'prop-types'

function ClipIcon({ title }) {
  const titleId = title ? 'clip-icon-title' : undefined

  return (
    <svg
      className="clipIcon"
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? 'img' : 'presentation'}
      aria-labelledby={titleId}
      aria-hidden={!title}
    >
      {title && <title id={titleId}>{title}</title>}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5022 4.54368L12.9442 5.94702L6.55062 12.3628C6.2298 12.6863 6.2298 13.2071 6.55062 13.5307C6.85506 13.8378 7.36363 13.8364 7.66481 13.529L14.6992 6.46741C15.7261 5.43179 15.7261 3.76857 14.6992 2.73294C13.7194 1.74484 11.9857 1.76682 11.0255 2.73482L3.34766 10.437C1.61421 12.1844 1.61421 14.9904 3.34766 16.7378C5.03091 18.4346 7.9225 18.407 9.57947 16.7362L18.5341 7.74899L19.9762 9.1522L11.0233 18.1378C8.58054 20.6008 4.38543 20.6409 1.90241 18.1379C-0.602522 15.6127 -0.602522 11.562 1.90413 9.03517L9.58196 1.33301C11.3259 -0.425057 14.3631 -0.463563 16.1447 1.33316C17.9427 3.14642 17.9427 6.05393 16.1431 7.86883L9.11296 14.9262C8.02547 16.0361 6.20616 16.0411 5.10497 14.9304C4.0132 13.8292 4.0132 12.0643 5.10679 10.9612L11.5022 4.54368Z"
        fill="#80B3FF"
      />
    </svg>
  )
}

ClipIcon.propTypes = {
  title: PropTypes.string,
}

export default ClipIcon
